import { useState, useEffect } from 'react';
import LoadingSpinner from '../LoadingSpinner';

import styles from './styles.module.scss';

const Room = ({ room, toggledAccessory, activeElementRef, isTutorialMode }) => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (room) {
      setLoading(false);
    }
  }, [room]);

  if (loading) return <LoadingSpinner />;
  return (
    <picture ref={isTutorialMode ? activeElementRef : null}>
      <img
        src={`${process.env.PUBLIC_URL}/images_iax/rooms/${room.key}.svg`}
        className={`${styles.roomBackground} ${
          toggledAccessory !== null && toggledAccessory.hotspot === 'TRUE'
            ? styles.transparent
            : ''
        } `}
        style={{ width: room.style_width }}
        alt={room.title}
      />
    </picture>
  );
};

export default Room;
